import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

const styles = {
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -18,
    marginRight: 10,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
};

function Title(props) {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <AppBar position="static"  style={{backgroundColor: '#abb119'}}>
        <Toolbar variant="dense">
          <Typography variant="h6" color="inherit"
              style={{paddingTop: '1.5%', paddingBottom: '1.5%'}}>
            VAIGAI CLAAS
          </Typography>
        </Toolbar>
      </AppBar>
    </div>
  );
}

Title.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Title);
